<div class="md-paragraph-toggle">
    <p
        #descTarget
        class="copy-description mb-8 {{ textStyle }}"
        [class.show-full-description]="showFullDescription"
        [class.elipsis]="!showFullDescription"
        [innerHtml]="content"
        [style.max-height]="maxHeight + 'px'"
        aria-labelledby="toggleDescriptionBtn"
    ></p>

    <button
        id="toggleDescriptionBtn"
        aria-label="Show description category"
        class="ttu btn-tertiary is-flex content-center w-100"
        (click)="toggleDescription()"
        *ngIf="descTarget.scrollHeight > maxHeight - 1"
    >
        <span class="leading-1 mr-4">
            <md-icon [name]="!showFullDescription ? 'plus' : 'minus'"></md-icon>
        </span>
    </button>
</div>
